

<div >
  <div class="daPic">
    <div style="text-align: center">
      <div class="titleFont" *ngIf="phoneApp" style="font-family: almoni; font-weight: bold; padding-top: 30%; color:white;font-size: 30px; padding-left: 0">Empty Returns/Dispatch </div>
    </div>
  </div>
</div>

<div class="centered" >

  <table class="mainTable" >
    <tr>
      <td class="mainUpperTd">

        <mat-card class="quickView" >
          <table style="width: 100%; border-collapse: collapse;margin: 0px; padding: 0px">
            <tr>
              <td style="width: 18%" >
                <div class="maher" (click)="myApp.showCharts()"></div>
              </td>

            </tr>
          </table>

          <div class="flex-item2" >
            <mat-accordion  style="z-index: 999; ">
              <span *ngFor="let items of mtReceiveArray; let row;let i = dataIndex">
              <mat-expansion-panel   >
                <mat-expansion-panel-header style="padding: 0px; padding-right: 20px;     border: red 1px solid;">
                  <mat-panel-title class="toolbarLetters" style="padding: 0px; color: white" (click)="accordianPressed()">
                    <div style="color: black;">
                      <button  mat-button style="min-width: 0; padding: 0 9px"></button>{{items.description}}
                    </div>
                  </mat-panel-title>
                </mat-expansion-panel-header>
                <mat-card style="background-color: #efefef; text-align: -webkit-center; border: rgb(192,0,0) 1px solid;" >
                  <div style="text-align: -webkit-left; padding-bottom: 20px;padding-left: 7px;">{{currentDate | date:'fullDate'}}</div>
                  <span *ngFor="let subs of items.messages">
                      <div *ngIf="subs.valueOf()!=null" class="theMessages">
                        <table>
                          <tr>
                            <td>
                              <img style="height: 30px; vertical-align: middle"  src="assets/arrow-circle.svg" >
                            </td>
                            <td [className]="subs.boldOn? 'boldOn' : 'boldOff' " >
                               {{subs.messageOut}}
                            </td>
                          </tr>
                        </table>


                      </div>
                  </span>
                </mat-card>
              </mat-expansion-panel>
                </span>
            </mat-accordion>
          </div>
        </mat-card>
      </td>
    </tr>
  </table>
</div>
